<template>
    <div>
        <header class="msite_header">
            <div v-if="type != 0" @click="goUpper">
                <div class="return">
                    <span class="iconfont iconfanhui">
                    </span>
                </div>
            </div>
            <span class="header_title">
                <span class="header_title_text ellipsis">{{title}}</span>
            </span>
            <slot name="right">
            </slot>
        </header>
        <div class="header_fill">

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        title: String,
        type: Number,
        isCustomeBack: Boolean
    },
    methods: {
        goUpper() {
            if(this.isCustomeBack){
                this.$emit("customeBackEvent");
            }else{
                this.$router.go(-1);
            }
        }
    }
};
</script>

<style>
.msite_header {
    background-color: #8a3e2f;
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
    width: 100%;
    height: 45px;
}
.msite_header .header_search {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    width: 10%;
    height: 50%;
}
.msite_header .header_search .icon-sousuo {
    font-size: 25px;
    color: #fff;
}
.msite_header .header_title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
    color: #fff;
    text-align: center;
}
.msite_header .header_title .header_title_text {
    font-size: 18px;
    color: #fff;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.msite_header .header_login {
    font-size: 14px;
    color: #fff;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
}
.msite_header .header_login .header_login_text {
    color: #fff;
}
.return {
    width: 20%;
    height: 100%;
}
.iconfanhui {
    color: #fff;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 20px;
}
.recharge-center {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: #ffffff;
}
.header_fill {
    height: 45px;
    width: 100%;
}
</style>
